import React, { useState, useEffect } from 'react';
import CameraCapture from './CameraCapture';
import PhotoViewer from './PhotoViewer';
import './OtherForm.css';

const MAX_PHOTOS = 3; // Limit photos per equipment item to prevent Firestore size issues

const OtherForm = ({ type, onSubmit, onClose }) => {
  const [notes, setNotes] = useState('');
  const [photos, setPhotos] = useState([]);
  const [showCamera, setShowCamera] = useState(false);
  const [showPhotoViewer, setShowPhotoViewer] = useState(false);

  // Cleanup effect to ensure camera is closed when form is unmounted
  useEffect(() => {
    return () => {
      // Force close camera when form is unmounted
      setShowCamera(false);
    };
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Ensure camera is closed before submitting
    setShowCamera(false);
    onSubmit({ notes, photos });
  };

  const handleClose = () => {
    // Ensure camera is closed when form is closed
    setShowCamera(false);
    onClose();
  };

  const handlePhotoCapture = (photoData) => {
    if (photos.length >= MAX_PHOTOS) {
      alert(`Maximum ${MAX_PHOTOS} photos allowed per item.`);
      return;
    }
    setPhotos([...photos, photoData]);
  };

  const handlePhotoDelete = (index) => {
    const newPhotos = photos.filter((_, i) => i !== index);
    setPhotos(newPhotos);
  };

  const getTypeLabel = () => {
    switch (type) {
      case 'general-note':
        return 'General Note';
      case 'tree-trimming':
        return 'Tree Trimming';
      default:
        return 'Other';
    }
  };

  return (
    <>
      <div className="other-form-container">
        <div className="other-form-content">
          <div className="other-form-header">
            <h2>{getTypeLabel()} Details</h2>
            <button className="close-button" onClick={handleClose}>&times;</button>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="form-field">
              <label htmlFor="notes">Notes</label>
              <textarea
                id="notes"
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
                placeholder={`Add ${getTypeLabel().toLowerCase()} notes here...`}
                rows={6}
                required
              />
            </div>
            
            {/* Photo Section */}
            <div className="form-field">
              <label>Photos ({photos.length}/{MAX_PHOTOS})</label>
              <div className="photo-section">
                {photos.length < MAX_PHOTOS && (
                  <button 
                    type="button" 
                    className="add-photo-button"
                    onClick={() => setShowCamera(true)}
                  >
                    Add Photo
                  </button>
                )}
                {photos.length > 0 && (
                  <button 
                    type="button" 
                    className="view-photos-button"
                    onClick={() => setShowPhotoViewer(true)}
                  >
                    View Photos ({photos.length})
                  </button>
                )}
                {photos.length >= MAX_PHOTOS && (
                  <div className="photo-limit-message">
                    Maximum {MAX_PHOTOS} photos reached
                  </div>
                )}
              </div>
            </div>
            
            <div className="form-actions">
              <button type="button" className="cancel-button" onClick={handleClose}>Cancel</button>
              <button type="submit" className="submit-button">Add {getTypeLabel()}</button>
            </div>
          </form>
        </div>
      </div>
      
      {/* Camera Modal */}
      {showCamera && (
        <CameraCapture
          onCapture={handlePhotoCapture}
          onClose={() => setShowCamera(false)}
        />
      )}
      
      {/* Photo Viewer Modal */}
      {showPhotoViewer && (
        <PhotoViewer
          photos={photos}
          onClose={() => setShowPhotoViewer(false)}
          onDelete={handlePhotoDelete}
        />
      )}
    </>
  );
};

export default OtherForm; 